// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260718/js/" + chunkId + "." + {"44":"b9af0ad7","225":"fd398e94","481":"250f2850","486":"6ae94c00","770":"72fdcfa4"}[chunkId] + ".0.7966463865124402.chunk.js";
};